import { render } from "./VendorEdit.vue?vue&type=template&id=4a7285c0"
import script from "./VendorEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Vendor/VendorEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a7285c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a7285c0', __exports__)) {
    api.reload('4a7285c0', __exports__)
  }
  
  module.hot.accept("./VendorEdit.vue?vue&type=template&id=4a7285c0", () => {
    api.rerender('4a7285c0', render)
  })

}


export default __exports__